import src from "IMAGE";
export default { src, width: 666, height: 206, blurWidth: 0, blurHeight: 0};
